import request from 'services/request';

export async function getDownloadExcel({ cancelToken, urlExcel }) {
  return request(urlExcel, {
    method: 'GET',
    cancelToken,
  });
}
